<template>
  <el-row :gutter="15">
    <el-col
      :xs="7"
      :sm="6"
      :md="6"
      :lg="5"
      :xl="5"
    >
      <Filters
        v-model="filters"
        :resource="$sdk.account"
        :primary-fields="[ 'reference', 'name', 'carrier_settings.charge_account', 'billing_abn', 'billing_acn', 'parent', 'status' ]"
        @sort="sort = $event; $refs.table.loadTable()"
        @apply="$refs.table.loadTable()"
        @ready="$refs.table.loadTable()"
      />
    </el-col>

    <el-col
      :xs="17"
      :sm="18"
      :md="18"
      :lg="19"
      :xl="19"
    >
      <el-card
        shadow="never"
      >
        <AccountsTable
          ref="table"
          :filters="filters"
          :sort="sort"
        />
      </el-card>

      <CreateAccountForm
        v-if="isShowCreateForm"
        ref="createForm"
        :is-show.sync="isShowCreateForm"
        @saved="$refs.table.loadTable"
      />
    </el-col>
  </el-row>
</template>

<script>
import Filters from '@/components/Filters/Simplified'
import AccountsTable from '@/components/Application/Manage/Accounts/Index'
import CreateAccountForm from '@/components/Application/Manage/Accounts/CreateAccountForm'
import { CREATE } from '@/plugins/user'

export default {
  components: {
    AccountsTable,
    CreateAccountForm,
    Filters
  },
  data () {
    return {
      title: 'Accounts',
      isShowCreateForm: false,
      actions: [
        {
          hidden: this.$user.cannot(CREATE, this.$sdk.account),
          name: 'Create',
          icon: ['fal', 'plus'],
          event: () => {
            this.isShowCreateForm = true
          }
        },
        {
          name: 'Refresh',
          icon: ['fal', 'sync'],
          event: () => {
            this.$refs.table.loadTable()
          }
        }
      ],
      filters: [],
      sort: {
        field: 'name',
        direction: 'asc'
      }
    }
  }
}
</script>
